// extracted by mini-css-extract-plugin
export default {"mediaPlaceholder":"MediaPlaceholder_mediaPlaceholder__XD2-n"};